export const translations = {
  it: {
    nav: {
      home: 'Home',
      about: 'Chi Siamo',
      services: 'Servizi',
      booking: 'Prenota',
      login: 'Accedi',
      logout: 'Esci',
      dashboard: 'Dashboard'
    },
    hero: {
      title: 'Studio Legale Nada Zhiti',
      subtitle: 'Consulenza legale professionale',
      cta: 'Prenota Consulenza',
      phone: 'Tel: 3462393411',
      address: 'Via Roma, 24 - Casale Monferrato'
    },
    languages: {
      title: 'Parliamo la tua lingua',
      subtitle: 'Consulenze disponibili in 5 lingue'
    },
    services: {
      title: 'I Nostri Servizi',
      immigration: 'Immigrazione',
      immigrationDesc: 'Un nuovo inizio merita la giusta assistenza. Ti accompagniamo passo dopo passo nelle pratiche di immigrazione, permessi di soggiorno e ricongiungimenti familiari. La tua storia è unica, la tua tutela è la nostra priorità.',
      criminal: 'Diritto Penale',
      criminalDesc: 'Quando i tuoi diritti sono in gioco, ogni parola conta. Difesa penale con passione e competenza: dalla tutela della persona alla lotta contro abusi e ingiustizie. Perché tutti meritano una difesa degna.',
      debt: 'Recupero Crediti',
      debtDesc: 'Il tuo lavoro ha valore, i tuoi crediti anche. Ti aiutiamo a recuperare ciò che ti spetta con determinazione e professionalità, dal sollecito bonario fino al pignoramento. Non lasciare che il tuo diritto resti sulla carta.',
      traffic: 'Infortunistica Stradale',
      trafficDesc: 'Un incidente può cambiare tutto in un attimo. Ti sosteniamo nella richiesta di risarcimento danni per sinistri stradali e infortuni personali. Dalla prima consulenza fino al completo ristoro: non sei solo.',
      inheritance: 'Diritto Successorio',
      inheritanceDesc: 'Proteggere il patrimonio di famiglia è un atto d\'amore. Assistenza completa in eredità, testamenti e successioni. Risolviamo controversie ereditarie tutelando i tuoi diritti e quelli dei tuoi cari.',
      rental: 'Diritto delle Locazioni',
      rentalDesc: 'Casa tua, diritti tuoi. Che tu sia proprietario o inquilino, ti assistiamo in contratti, contenziosi, sfratti e canoni di locazione. Ogni situazione merita la giusta soluzione legale.',
      family: 'Diritto di Famiglia',
      familyDesc: 'I momenti difficili richiedono massima delicatezza. Ti guidiamo con empatia in separazioni, divorzi e tutela dei figli. Perché anche quando una storia finisce, i tuoi diritti e il benessere dei tuoi figli vengono prima di tutto.',
      support: 'Amministrazione di Sostegno',
      supportDesc: 'Proteggere chi ami è naturale. Ti affianchiamo nelle pratiche di amministrazione di sostegno per garantire dignità e tutela a chi ha più bisogno. Un supporto legale fatto di competenza e umanità.'
    },
    auth: {
      login: 'Accedi',
      register: 'Registrati',
      email: 'Email',
      password: 'Password',
      firstName: 'Nome',
      lastName: 'Cognome',
      phone: 'Telefono',
      country: 'Nazione',
      birthDate: 'Data di nascita',
      birthPlace: 'Luogo di nascita',
      nationality: 'Nazionalità',
      caseDescription: 'Descrivi la tua problematica',
      privacyConsent: 'Acconsento al trattamento dei dati personali',
      haveAccount: 'Hai già un account?',
      noAccount: 'Non hai un account?',
      loginButton: 'Accedi',
      registerButton: 'Registrati'
    },
    dashboard: {
      welcome: 'Benvenuto',
      myAppointments: 'I Miei Appuntamenti',
      bookNew: 'Prenota Nuova Consulenza',
      upcoming: 'Prossimi Appuntamenti',
      past: 'Appuntamenti Passati',
      status: 'Stato',
      date: 'Data',
      time: 'Ora',
      payment: 'Pagamento',
      pending: 'In attesa',
      confirmed: 'Confermato',
      completed: 'Completato',
      notifications: 'Notifiche',
      confirmAppointment: 'Conferma Appuntamento'
    },
    booking: {
      title: 'Prenota Consulenza',
      selectDate: 'Seleziona Data',
      selectTime: 'Seleziona Orario',
      available: 'Disponibile',
      booked: 'Già assegnato',
      confirm: 'Conferma Prenotazione',
      paymentRequired: 'Pagamento Richiesto',
      amount: 'Importo',
      payNow: 'Paga Ora',
      bookingSuccess: 'Prenotazione effettuata con successo'
    },
    admin: {
      title: 'Pannello Admin',
      manageSlots: 'Gestisci Slot',
      createSlot: 'Crea Nuovo Slot',
      allAppointments: 'Tutti gli Appuntamenti',
      client: 'Cliente',
      delete: 'Elimina'
    }
  },
  sq: {
    nav: {
      home: 'Ballina',
      about: 'Rreth Nesh',
      services: 'Shërbimet',
      booking: 'Rezervo',
      login: 'Hyr',
      logout: 'Dil',
      dashboard: 'Paneli'
    },
    hero: {
      title: 'Studio Ligjor Nada Zhiti',
      subtitle: 'Këshillim ligjor profesional',
      cta: 'Rezervo Konsulencë',
      phone: 'Tel: 3462393411',
      address: 'Via Roma, 24 - Casale Monferrato'
    },
    languages: {
      title: 'Flasim gjuhën tuaj',
      subtitle: 'Konsulenca në 5 gjuhë'
    },
    services: {
      title: 'Shërbimet Tona',
      immigration: 'Imigracion',
      immigrationDesc: 'Asistencë e plotë për procedurat e imigracionit',
      debt: 'Rikuperimi i Borxheve',
      debtDesc: 'Këshillim dhe mbështetje për rikuperimin e borxheve',
      support: 'Administrimi i Mbështetjes',
      supportDesc: 'Asistencë ligjore për administrimin e mbështetjes'
    },
    auth: {
      login: 'Hyr',
      register: 'Regjistrohu',
      email: 'Email',
      password: 'Fjalëkalimi',
      firstName: 'Emri',
      lastName: 'Mbiemri',
      phone: 'Telefoni',
      country: 'Shteti',
      birthDate: 'Data e lindjes',
      birthPlace: 'Vendi i lindjes',
      nationality: 'Kombësia',
      caseDescription: 'Përshkruani problemin tuaj',
      privacyConsent: 'Pranoj trajtimin e të dhënave personale',
      haveAccount: 'Keni një llogari?',
      noAccount: 'Nuk keni një llogari?',
      loginButton: 'Hyr',
      registerButton: 'Regjistrohu'
    },
    dashboard: {
      welcome: 'Mirë se vini',
      myAppointments: 'Takimet e Mia',
      bookNew: 'Rezervo Konsulencë të Re',
      upcoming: 'Takime të Ardhshme',
      past: 'Takime të Kaluara',
      status: 'Statusi',
      date: 'Data',
      time: 'Ora',
      payment: 'Pagesa',
      pending: 'Në pritje',
      confirmed: 'Konfirmuar',
      completed: 'Përfunduar',
      notifications: 'Njoftimet',
      confirmAppointment: 'Konfirmo Takimin'
    },
    booking: {
      title: 'Rezervo Konsulencë',
      selectDate: 'Zgjidh Datën',
      selectTime: 'Zgjidh Orën',
      available: 'I disponueshëm',
      booked: 'Tashmë i caktuar',
      confirm: 'Konfirmo Rezervimin',
      paymentRequired: 'Pagesa e Kërkuar',
      amount: 'Shuma',
      payNow: 'Paguaj Tani',
      bookingSuccess: 'Rezervimi u krye me sukses'
    },
    admin: {
      title: 'Paneli Admin',
      manageSlots: 'Menaxho Slotet',
      createSlot: 'Krijo Slot të Ri',
      allAppointments: 'Të Gjitha Takimet',
      client: 'Klienti',
      delete: 'Fshi'
    }
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      about: 'من نحن',
      services: 'الخدمات',
      booking: 'احجز',
      login: 'تسجيل الدخول',
      logout: 'تسجيل الخروج',
      dashboard: 'لوحة التحكم'
    },
    hero: {
      title: 'مكتب المحاماة نادا زيتي',
      subtitle: 'استشارات قانونية محترفة',
      cta: 'احجز استشارة',
      phone: 'هاتف: 3462393411',
      address: 'فيا روما، 24 - كازالي مونفيراتو'
    },
    languages: {
      title: 'نتحدث لغتك',
      subtitle: 'استشارات متاحة بـ 5 لغات'
    },
    services: {
      title: 'خدماتنا',
      immigration: 'الهجرة',
      immigrationDesc: 'مساعدة كاملة في إجراءات الهجرة',
      debt: 'تحصيل الديون',
      debtDesc: 'استشارات ودعم في تحصيل الديون',
      support: 'إدارة الدعم',
      supportDesc: 'مساعدة قانونية في إدارة الدعم'
    },
    auth: {
      login: 'تسجيل الدخول',
      register: 'التسجيل',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      firstName: 'الاسم الأول',
      lastName: 'اسم العائلة',
      phone: 'الهاتف',
      country: 'البلد',
      birthDate: 'تاريخ الميلاد',
      birthPlace: 'مكان الميلاد',
      nationality: 'الجنسية',
      caseDescription: 'صف مشكلتك',
      privacyConsent: 'أوافق على معالجة البيانات الشخصية',
      haveAccount: 'هل لديك حساب؟',
      noAccount: 'ليس لديك حساب؟',
      loginButton: 'دخول',
      registerButton: 'تسجيل'
    },
    dashboard: {
      welcome: 'مرحبا',
      myAppointments: 'مواعيدي',
      bookNew: 'احجز استشارة جديدة',
      upcoming: 'المواعيد القادمة',
      past: 'المواعيد السابقة',
      status: 'الحالة',
      date: 'التاريخ',
      time: 'الوقت',
      payment: 'الدفع',
      pending: 'قيد الانتظار',
      confirmed: 'مؤكد',
      completed: 'مكتمل',
      notifications: 'الإشعارات',
      confirmAppointment: 'تأكيد الموعد'
    },
    booking: {
      title: 'احجز استشارة',
      selectDate: 'اختر التاريخ',
      selectTime: 'اختر الوقت',
      available: 'متاح',
      booked: 'محجوز بالفعل',
      confirm: 'تأكيد الحجز',
      paymentRequired: 'الدفع مطلوب',
      amount: 'المبلغ',
      payNow: 'ادفع الآن',
      bookingSuccess: 'تم الحجز بنجاح'
    },
    admin: {
      title: 'لوحة الإدارة',
      manageSlots: 'إدارة الفترات',
      createSlot: 'إنشاء فترة جديدة',
      allAppointments: 'جميع المواعيد',
      client: 'العميل',
      delete: 'حذف'
    }
  },
  zh: {
    nav: {
      home: '首页',
      about: '关于我们',
      services: '服务',
      booking: '预约',
      login: '登录',
      logout: '退出',
      dashboard: '控制面板'
    },
    hero: {
      title: 'Nada Zhiti律师事务所',
      subtitle: '专业法律咨询',
      cta: '预约咨询',
      phone: '电话：3462393411',
      address: 'Via Roma, 24 - Casale Monferrato'
    },
    languages: {
      title: '我们说您的语言',
      subtitle: '提供5种语言的咨询'
    },
    services: {
      title: '我们的服务',
      immigration: '移民',
      immigrationDesc: '移民程序的全面协助',
      debt: '债务追收',
      debtDesc: '债务追收的咨询和支持',
      support: '支持管理',
      supportDesc: '支持管理的法律协助'
    },
    auth: {
      login: '登录',
      register: '注册',
      email: '电子邮件',
      password: '密码',
      firstName: '名',
      lastName: '姓',
      phone: '电话',
      country: '国家',
      birthDate: '出生日期',
      birthPlace: '出生地',
      nationality: '国籍',
      caseDescription: '描述您的问题',
      privacyConsent: '我同意处理个人数据',
      haveAccount: '已有账户？',
      noAccount: '没有账户？',
      loginButton: '登录',
      registerButton: '注册'
    },
    dashboard: {
      welcome: '欢迎',
      myAppointments: '我的预约',
      bookNew: '预约新咨询',
      upcoming: '即将到来的预约',
      past: '过去的预约',
      status: '状态',
      date: '日期',
      time: '时间',
      payment: '付款',
      pending: '待处理',
      confirmed: '已确认',
      completed: '已完成',
      notifications: '通知',
      confirmAppointment: '确认预约'
    },
    booking: {
      title: '预约咨询',
      selectDate: '选择日期',
      selectTime: '选择时间',
      available: '可用',
      booked: '已预约',
      confirm: '确认预约',
      paymentRequired: '需要付款',
      amount: '金额',
      payNow: '立即支付',
      bookingSuccess: '预约成功'
    },
    admin: {
      title: '管理面板',
      manageSlots: '管理时段',
      createSlot: '创建新时段',
      allAppointments: '所有预约',
      client: '客户',
      delete: '删除'
    }
  },
  ur: {
    nav: {
      home: 'ہوم',
      about: 'ہمارے بارے میں',
      services: 'خدمات',
      booking: 'بکنگ',
      login: 'لاگ ان',
      logout: 'لاگ آؤٹ',
      dashboard: 'ڈیش بورڈ'
    },
    hero: {
      title: 'اسٹوڈیو لیگل نادا زیتی',
      subtitle: 'پیشہ ورانہ قانونی مشاورت',
      cta: 'مشاورت بک کریں',
      phone: 'فون: 3462393411',
      address: 'Via Roma, 24 - Casale Monferrato'
    },
    languages: {
      title: 'ہم آپ کی زبان بولتے ہیں',
      subtitle: '5 زبانوں میں مشاورت دستیاب'
    },
    services: {
      title: 'ہماری خدمات',
      immigration: 'امیگریشن',
      immigrationDesc: 'امیگریشن کے طریقہ کار کے لیے مکمل معاونت',
      debt: 'قرض کی وصولی',
      debtDesc: 'قرض کی وصولی کے لیے مشاورت اور معاونت',
      support: 'سپورٹ کا انتظام',
      supportDesc: 'سپورٹ کے انتظام کے لیے قانونی معاونت'
    },
    auth: {
      login: 'لاگ ان',
      register: 'رجسٹر',
      email: 'ای میل',
      password: 'پاس ورڈ',
      firstName: 'پہلا نام',
      lastName: 'آخری نام',
      phone: 'فون',
      country: 'ملک',
      birthDate: 'تاریخ پیدائش',
      birthPlace: 'پیدائش کی جگہ',
      nationality: 'قومیت',
      caseDescription: 'اپنے مسئلے کی وضاحت کریں',
      privacyConsent: 'میں ذاتی ڈیٹا کی پروسیسنگ سے اتفاق کرتا ہوں',
      haveAccount: 'کیا آپ کا اکاؤنٹ ہے؟',
      noAccount: 'اکاؤنٹ نہیں ہے؟',
      loginButton: 'لاگ ان',
      registerButton: 'رجسٹر'
    },
    dashboard: {
      welcome: 'خوش آمدید',
      myAppointments: 'میری ملاقاتیں',
      bookNew: 'نئی مشاورت بک کریں',
      upcoming: 'آنے والی ملاقاتیں',
      past: 'گزشتہ ملاقاتیں',
      status: 'حالت',
      date: 'تاریخ',
      time: 'وقت',
      payment: 'ادائیگی',
      pending: 'زیر التواء',
      confirmed: 'تصدیق شدہ',
      completed: 'مکمل',
      notifications: 'اطلاعات',
      confirmAppointment: 'ملاقات کی تصدیق کریں'
    },
    booking: {
      title: 'مشاورت بک کریں',
      selectDate: 'تاریخ منتخب کریں',
      selectTime: 'وقت منتخب کریں',
      available: 'دستیاب',
      booked: 'پہلے سے مختص',
      confirm: 'بکنگ کی تصدیق کریں',
      paymentRequired: 'ادائیگی درکار',
      amount: 'رقم',
      payNow: 'ابھی ادا کریں',
      bookingSuccess: 'بکنگ کامیابی سے مکمل ہوئی'
    },
    admin: {
      title: 'ایڈمن پینل',
      manageSlots: 'سلاٹس کا انتظام کریں',
      createSlot: 'نیا سلاٹ بنائیں',
      allAppointments: 'تمام ملاقاتیں',
      client: 'کلائنٹ',
      delete: 'حذف کریں'
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      about: 'À Propos',
      services: 'Services',
      booking: 'Réserver',
      login: 'Connexion',
      logout: 'Déconnexion',
      dashboard: 'Tableau de Bord'
    },
    hero: {
      title: 'Cabinet d\'Avocats Nada Zhiti',
      subtitle: 'Conseil juridique professionnel',
      cta: 'Réserver une Consultation',
      phone: 'Tél: 3462393411',
      address: 'Via Roma, 24 - Casale Monferrato'
    },
    languages: {
      title: 'Nous parlons votre langue',
      subtitle: 'Consultations disponibles en 5 langues'
    },
    services: {
      title: 'Nos Services',
      immigration: 'Immigration',
      immigrationDesc: 'Assistance complète pour les démarches d\'immigration',
      debt: 'Recouvrement de Créances',
      debtDesc: 'Conseil et soutien pour le recouvrement de créances',
      support: 'Administration de Soutien',
      supportDesc: 'Assistance juridique pour l\'administration de soutien'
    },
    auth: {
      login: 'Connexion',
      register: 'S\'inscrire',
      email: 'Email',
      password: 'Mot de passe',
      firstName: 'Prénom',
      lastName: 'Nom',
      phone: 'Téléphone',
      country: 'Pays',
      birthDate: 'Date de naissance',
      birthPlace: 'Lieu de naissance',
      nationality: 'Nationalité',
      caseDescription: 'Décrivez votre problème',
      privacyConsent: 'J\'accepte le traitement des données personnelles',
      haveAccount: 'Vous avez déjà un compte?',
      noAccount: 'Vous n\'avez pas de compte?',
      loginButton: 'Se connecter',
      registerButton: 'S\'inscrire'
    },
    dashboard: {
      welcome: 'Bienvenue',
      myAppointments: 'Mes Rendez-vous',
      bookNew: 'Réserver une Nouvelle Consultation',
      upcoming: 'Rendez-vous à Venir',
      past: 'Rendez-vous Passés',
      status: 'Statut',
      date: 'Date',
      time: 'Heure',
      payment: 'Paiement',
      pending: 'En attente',
      confirmed: 'Confirmé',
      completed: 'Terminé',
      notifications: 'Notifications',
      confirmAppointment: 'Confirmer le Rendez-vous'
    },
    booking: {
      title: 'Réserver une Consultation',
      selectDate: 'Sélectionner la Date',
      selectTime: 'Sélectionner l\'Heure',
      available: 'Disponible',
      booked: 'Déjà attribué',
      confirm: 'Confirmer la Réservation',
      paymentRequired: 'Paiement Requis',
      amount: 'Montant',
      payNow: 'Payer Maintenant',
      bookingSuccess: 'Réservation effectuée avec succès'
    },
    admin: {
      title: 'Panneau Admin',
      manageSlots: 'Gérer les Créneaux',
      createSlot: 'Créer un Nouveau Créneau',
      allAppointments: 'Tous les Rendez-vous',
      client: 'Client',
      delete: 'Supprimer'
    }
  }
};